import { Globe } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const languages = [
  { code: "en" as const, label: "EN" },
  { code: "sl" as const, label: "SI" },
];

const LanguageSelector = () => {
  const { lang, setLang } = useLanguage();

  return (
    <div className="flex items-center gap-1 text-sm text-foreground/60">
      <Globe className="w-4 h-4" />
      {languages.map((l, i) => (
        <span key={l.code}>
          <button
            onClick={() => setLang(l.code)}
            className={`hover:text-foreground transition-colors ${lang === l.code ? "text-foreground font-semibold" : ""}`}
          >
            {l.label}
          </button>
          {i < languages.length - 1 && <span className="mx-0.5">/</span>}
        </span>
      ))}
    </div>
  );
};

export default LanguageSelector;
